import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import commonEN from "./common-en.json";
import commonZH from "./common-zh.json";
import en from "./en.json";
import zh from "./zh-CN.json";
import routes from "./local/routes.json"; // ✅ 添加routes.json文件
import routesEn from "./local/routes_en.json"; // ✅ 添加routes.json文件
// 配置语言检测选项
const detectionOptions = {
  // 检测顺序，优先使用localStorage
  order: ["localStorage", "navigator", "htmlTag"],

  // 缓存用户语言
  caches: ["localStorage"],

  // localStorage的key
  lookupLocalStorage: "i18nextLng",

  // 不检查URL参数和cookie
  excludeCacheFor: [],

  // 语言映射配置
  convertDetectedLanguage: (lng: string) => {
    // 将浏览器检测到的语言标准化
    let convertedLng = lng;
    if (lng.startsWith("zh")) convertedLng = "zh";
    if (lng.startsWith("en")) convertedLng = "en";
    return convertedLng;
  },
};
const resources = {
  en: { translation: { ...commonEN, ...routesEn, ...en } },
  zh: { translation: { ...commonZH, ...routes, ...zh } }, // ✅ 添加common合并
  // jp: { translation: { ...common, ...jp } }, // TODO: 添加jp.json文件
};

i18n
  .use(LanguageDetector) // Automatically detects user language
  .use(initReactI18next)
  .init({
    resources,
    lng: undefined, // default language
    fallbackLng: ["zh", "en"], // 调整fallback顺序，优先中文
    detection: detectionOptions, // 添加检测配置
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    // 添加调试配置
    debug: process.env.NODE_ENV === "development",
    // 添加命名空间支持
    defaultNS: "translation",
    // 当翻译缺失时的行为
    parseMissingKeyHandler: (key) => {
      console.warn(`Missing translation key: ${key}`);
      return key;
    },
    // 确保语言切换后立即生效
    load: "languageOnly",
    // 强制重新加载
    initImmediate: false,
  })
  .then(() => {
    // 初始化完成后的调试信息
    console.log("i18n初始化完成");
    console.log("当前语言:", i18n.language);
    console.log("localStorage中的语言:", localStorage.getItem("i18nextLng"));
    console.log("可用的语言资源:", Object.keys(resources));
    console.log(
      "当前使用的资源:",
      i18n.hasResourceBundle(i18n.language, "translation")
    );
  });

// 添加语言变化监听
i18n.on("languageChanged", (lng) => {
  console.log("语言已切换到:", lng);
});

export default i18n;
